var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpPulse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.741 4.88809C26.0394 5.38009 24.4162 6.11929 22.7138 6.60729C19.3786 7.56329 15.8514 7.52969 12.4122 7.98329C8.97297 8.43689 5.39617 9.50729 3.10897 12.1153C0.136171 15.5049 0.167372 20.8673 2.44417 24.7585C4.72097 28.6497 8.84177 31.1849 13.1602 32.4809C16.7298 33.5521 20.5594 33.8713 24.2082 33.1129C27.857 32.3545 31.3114 30.4785 33.721 27.6361C35.405 25.6497 36.5426 23.2593 37.485 20.8321C38.6874 17.7345 39.613 14.3801 39.0146 11.1113C37.977 5.44809 32.905 3.39449 27.741 4.88809Z",
    fill: "#F8BEC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1777 33.1792C35.6018 33.1792 35.9457 32.8353 35.9457 32.4112C35.9457 31.987 35.6018 31.6432 35.1777 31.6432C34.7535 31.6432 34.4097 31.987 34.4097 32.4112C34.4097 32.8353 34.7535 33.1792 35.1777 33.1792Z",
    fill: "#FDCB4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81689 35.2601C1.81689 34.8361 2.16009 34.4921 2.58489 34.4921C3.00969 34.4921 3.35289 34.8353 3.35289 35.2601C3.35289 35.6849 3.00969 36.0281 2.58489 36.0281C2.16009 36.0281 1.81689 35.6849 1.81689 35.2601Z",
    fill: "#781BFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7353 1.67443C32.1594 1.67443 32.5033 1.33058 32.5033 0.906428C32.5033 0.482273 32.1594 0.138428 31.7353 0.138428C31.3111 0.138428 30.9673 0.482273 30.9673 0.906428C30.9673 1.33058 31.3111 1.67443 31.7353 1.67443Z",
    fill: "#4CB648"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11095_153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 16C13.691 16 11 13.309 11 10C11 6.691 13.691 4 17 4C20.309 4 23 6.691 23 10C23 13.309 20.309 16 17 16ZM29.535 24H32V22H28.465L27.124 24.012L24.124 18.012L21.465 22H19V24H22.535L23.876 21.988L26.876 28L29.535 24ZM23.646 26H17V20H20.394L21.681 18.069C21.456 18.038 21.233 18 20.999 18H13C10.243 18 8 20.243 8 23V28H24.646L23.646 26Z",
    fill: "#623D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11095_153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpPulse);
export default __webpack_public_path__ + "static/media/emp-pulse.5513e9d5965c481d2d542ee15435a888.svg";
export { ForwardRef as ReactComponent };